"use client";

import { Button } from "@ui/components/core/Button";
import { useTranslations } from "next-intl";
import { HeroAgentCardLayout, ResendButton, ResizableProgressBar } from "./Components";

export interface CallScheduledViewProps {
  onClose: () => void;
  onResend: () => void;
  currentStep?: number;
  /** Total number of steps for progress indicator */
  totalSteps?: number;
}

export function CallScheduledView({ onClose, onResend, currentStep = 2, totalSteps = 3 }: CallScheduledViewProps) {
  const t = useTranslations("ClientKeys.hero_agent.views.call_scheduled");

  return (
    <HeroAgentCardLayout width='full' className='tw-h-full tw-flex tw-flex-col tw-overflow-x-hidden tw-py-2.5'>
      {/* Header */}
      <div className='tw-flex tw-flex-col tw-max-w-sm'>
        <h3 className='tw-mb-4 tw-type-2xl'>{t("title")}</h3>
        <p className='tw-text-gray-500 tw-mb-2 tw-type-xs'>{t("subtitle")}</p>
      </div>

      {/* Resend Link */}
      <p className='tw-text-gray-500 tw-type-xs tw-pt-3'>
        {t("didnt_get_call")}{" "}
        <ResendButton
          onResend={onResend}
          initialAttempts={1}
          minCooldownSeconds={45}
          enabledContent={() => <span className='tw-font-semibold tw-text-black'>{t("resend_now")}</span>}
          disabledContent={({ cooldown, attempts, maxAttempts }) => (
            <span className='tw-text-gray-400'>
              {attempts >= maxAttempts ? t("max_attempts_reached") : t("resend_in", { seconds: cooldown })}
            </span>
          )}
        />
      </p>

      {/* TODO - Add a graphic here */}
      <div className='tw-flex-1 tw-flex tw-items-center tw-justify-center tw-py-8' />

      {/* Footer with actions and progress */}
      <div className='tw-flex tw-items-center tw-justify-between tw-mt-auto tw-py-1.5 tw-gap-4'>
        {/* Left side - Close button */}
        <Button type='button' variant='elevated' size='lg' onClick={onClose}>
          {t("close")}
        </Button>

        {/* Right side - Progress indicator */}

        <ResizableProgressBar currentStep={currentStep} totalSteps={totalSteps} />
      </div>
    </HeroAgentCardLayout>
  );
}
